import { UserService } from '@/api/user';
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  PropsWithChildren,
} from 'react';

type AccessContextType = { [projectId: string]: boolean } | null;

const AccessContext = createContext<AccessContextType>(null);

export const AccessProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [access, setAccess] = useState<AccessContextType>(null);
  const { data: assignees } = UserService.useGetProjectAssignees();

  useEffect(() => {
    if (assignees) {
      const accessMap: { [projectId: string]: boolean } = {};

      assignees?.project_assignees.forEach(
        (item: { access: string; project_id: string }) => {
          if (item.access === 'VIEWER' && assignees.user_type === 'TESTER') {
            accessMap[item.project_id] = true;
          } else {
            accessMap[item.project_id] = false;
          }
        },
      );

      setAccess(accessMap);
    }
  }, [assignees]);

  return (
    <AccessContext.Provider value={access}>{children}</AccessContext.Provider>
  );
};

const Access = (): AccessContextType => {
  return useContext(AccessContext);
};

export const useAccess = (projectId: string): boolean => {
  const access = Access();

  return access ? !!access[projectId] : false;
};
